
















































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {deleteProduct} from '@/ts/products/delete-product';
import {getProducts} from '@/ts/products/get-products';

export default {
    name: 'TheTableProducts',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {
        };
    },
    methods: {
        FireModal(product_id) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteProduct(this.$route.params.id, product_id).then(() => {
                        this.$swal.fire('Изтриването успешно!', '', 'success');
                    });
                    const index = this.$store.state.response.response.findIndex((item) => item.id === product_id);
                    this.$store.state.response.response.splice(index, index);
                }
            });
        },
        sort(temp) {
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            getProducts(this.$route.params.id, this.$route.params.category_id);
        },
    },
};
